import { getGeneralInfo, setTermsConditions } from "./account";

export async function checkUserAgreement(userData){
    const generalInfoDoc = await getGeneralInfo();
    if(!userData.termsPolicyVersion){
        createTermsPopup(generalInfoDoc.termsPolicyVersion)
    }
    else if(generalInfoDoc.termsPolicyVersion != userData.termsPolicyVersion){
        createTermsPopup(generalInfoDoc.termsPolicyVersion)
    }
}

function createTermsPopup(termsPolicyVersion){
    const element = `
        <div class="cantClosePopup" id="termsConditionsPopup">
            <div class="popupBox">
                <h1 class="popupTitle">TERMS & CONDITIONS<br>PRIVACY POLICY</h1>
                <span class="popupDescription">My Terms and Conditions or Privacy Policy have been updated please agree to the following.</span>
                <div class="checkBoxBox">
                    <span class="termsLink">I am 13 years or older</span>
                    <input type="checkbox" id="termsOlderThan13" class="checkBox">
                </div>
                <div class="checkBoxBox">
                    <a href="https://anaveragegame.com/privacyPolicy.pdf" class="termsLink">
                        I have read and accept the Privacy Policy
                    </a>
                    <input type="checkbox" id="termsPrivacyPolicy" class="checkBox">
                </div>
                <div class="checkBoxBox">
                    <a href="https://anaveragegame.com/termsConditions.pdf" class="termsLink">
                      I have read and accept the Terms and Conditions
                    </a>
                    <input type="checkbox" id="termsTermsConditions" class="checkBox">
                </div>
                <button class="btn closePopup" style="margin-top: 1px; background-color:  rgb(100, 100, 100);" id="closeTermsConditions">CLOSE</button>
            </div>
        </div>
    `
    document.body.insertAdjacentHTML('afterbegin',element)
    document.getElementById("closeTermsConditions").addEventListener('click',()=>{
        const olderThanThirteen = document.getElementById("termsOlderThan13").checked
        const termsPrivacyPolicy = document.getElementById("termsPrivacyPolicy").checked
        const termsTermsConditions = document.getElementById("termsTermsConditions").checked
        if(olderThanThirteen && termsPrivacyPolicy && termsTermsConditions){
            updateTermsConditions(termsPolicyVersion)
        }
    })
}

async function updateTermsConditions(termsPolicyVersion){
    document.getElementById("termsConditionsPopup").remove()
    await setTermsConditions(termsPolicyVersion)
}